import { Node as ProseMirrorNode } from '@tiptap/pm/model';

const cellHasContent = (cell: ProseMirrorNode): boolean =>
  // content.size > 2 means it has more than just an empty paragraph
  // textContent.trim().length > 0 ensures there's actual text, not just whitespace
  cell.content.size > 2 && cell.textContent.trim().length > 0;

export const rowHasContent = (row: ProseMirrorNode): boolean => {
  let hasContent = false;

  row.forEach((cell) => {
    if ((cell.type.name === 'tableCell' || cell.type.name === 'tableHeader') && cellHasContent(cell)) {
      hasContent = true;
    }
  });

  return hasContent;
};

export const tableHasContent = (table: ProseMirrorNode): boolean => {
  let hasValidRow = false;

  table.forEach((child) => {
    if (child.type.name === 'tableRow' && rowHasContent(child)) {
      hasValidRow = true;
    }
  });

  return hasValidRow;
};
